import { render } from "./AccountsActiveList.vue?vue&type=template&id=3e07c3d4"
import script from "./AccountsActiveList.vue?vue&type=script&lang=js"
export * from "./AccountsActiveList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__